import { BaseSepoliaTestnet } from '@thirdweb-dev/chains';

// Agoracle Global — on-chain layer configuration.
//
// Base Sepolia is the free testnet flavour of Coinbase's Base L2. We
// stay on the testnet through Phase 1 so citizens can link MetaMask
// without spending real gas. Flip to Base mainnet (chainId 8453) only
// when the Sovereign Exchange work in Phase 3 is ready to settle real
// USDC.

export const ACTIVE_CHAIN = BaseSepoliaTestnet;

// Client ID for Thirdweb's managed services (IPFS gateway, RPC,
// embedded wallet auth). Missing this is the 401 Unauthorized we've
// been seeing on /global — Thirdweb's RPC layer rejects calls without
// a valid key. We probe three env-var namespaces (CRA, Next, Vite) to
// survive copy-paste from any of Thirdweb's three starter templates,
// and fall back to the original REACT_APP_THIRDWEB_CLIENT_ID for
// backward compat with whatever is already set on Vercel.
export const THIRDWEB_CLIENT_ID =
  process.env.REACT_APP_TEMPLATE_CLIENT_ID ||
  process.env.NEXT_PUBLIC_TEMPLATE_CLIENT_ID ||
  process.env.VITE_TEMPLATE_CLIENT_ID ||
  process.env.REACT_APP_THIRDWEB_CLIENT_ID ||
  undefined;
